import _ from "lodash";

export const DATASET_TYPE_FILTERS = {
  TODDLE_MANAGED: "TODDLE_MANAGED",
  CUSTOM: "CUSTOM",
};

export const CUSTOM_PLANNER_ELEMENT_SET_TYPES = [
  "NESTED_CHECKLIST",
  "CHECKLIST",
  "CARD",
];

export const getUiTypeLabels = t => ({
  NESTED_CHECKLIST: t("common:nested_checklist"),
  CHECKLIST: t("common:checklist"),
  CARD: t("common:card"),
});

export const getIsCustomPlannerElementSetType = type =>
  _.includes(CUSTOM_PLANNER_ELEMENT_SET_TYPES, type);
